// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cceabd30","703":"e80d501c","787":"7c188a15"}[chunkId] + ".chunk.js";
};